export default "__VITE_ASSET__CzcQuwlR__"